export const FilterTypes = {
    SHOW_FILTER_BUILDING: "SHOW_FILTER_BUILDING",
    SHOW_FILTER_GROUPS: "SHOW_FILTER_GROUPS",

}